export default "__VITE_ASSET__CNR$qSbi__"